<template>
    <div class="classroomLights_main" :class="{'cn':version == '1'}">
        <div class="classroomLights_left">
            <!-- <side-bar></side-bar> -->
        </div>
        <div class="classroomLights_right">
            <div class="classroomLights_right_top">
                <div class="right_top_l">
                    <el-select v-model="buildId" @change="buildIdChange">
                        <el-option
                          v-for="item in buildNav"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id">
                        </el-option>
                    </el-select>
                    <el-input :placeholder="$t('App.lights.text24')" v-model="keywords" @keyup.native="getLightListKeyUp($event)" class="input-with-select">
                        <i slot="suffix" class="el-input__icon el-icon-search" @click="getLightList()"></i>
                    </el-input>
                </div>
            </div>
            <div class="classroomLights_right_main">
                <div class="main_top">
                    <div class="main_top_l">
                        <div class="div1"><span>{{$t('App.sideBar.text23')}}</span></div>
                    </div>
                    <!-- <div class="main_top_r">
                        <div class="btn" @click="lightsFun()"><img :src="img_lights_0"><span>{{$t('App.lights.text5')}}</span></div>
                    </div> -->
                </div>
                <div class="main_cont">
                    <!-- <el-checkbox-group v-model="checkList" @change="handleCheckedCitiesChange"> -->
                            <!-- element-loading-background="rgba(0, 0, 0, 0.5)" -->
                        <el-table
                            ref="lightDataList"
                            v-loading="loading.lightDataList"
                            height="100%"
                            @cell-mouse-enter="tableEnter"
                            @cell-mouse-leave="tableLeave"
                            :data="lightDataList">
                            <el-table-column
                                :label="$t('App.lights.text33')"
                                :prop="'webIndex'"
                                align="center"
                                header-align="center"
                                :width="6*remRatio">
                            </el-table-column>
                            <el-table-column
                                :label="'分组地址'"
                                :prop="'cluster'"
                                header-align="left"
                                align="left"
                                :show-overflow-tooltip="true"
                                :min-width="6.5*remRatio">
                            </el-table-column>
                            <el-table-column
                                :label="'网关地址'"
                                :prop="'gatewayId'"
                                header-align="left"
                                align="left"
                                :show-overflow-tooltip="true"
                                :min-width="6.5*remRatio">
                            </el-table-column>
                            <el-table-column
                                :label="$t('App.floor')"
                                :prop="'floorNumber'"
                                align="center"
                                :show-overflow-tooltip="true"
                                :min-width="5*remRatio">
                                 <!-- <template slot="header" slot-scope="scope">
                                    <div class="floor_header" @click="floorTypeFun(scope)">
                                        <p><span>{{floorName}}</span><i class="el-icon-arrow-down"></i></p>
                                        <el-select v-model="floorId" placeholder="" @change="floorIdChange" ref="floorRef">
                                            <el-option
                                              v-for="item in tableFloorNav"
                                              :key="item.id"
                                              :label="item.name"
                                              :value="item.id">
                                            </el-option>
                                        </el-select>
                                    </div>
                                </template> -->
                            </el-table-column>
                            <el-table-column
                                :label="$t('App.room.text1')"
                                :prop="'roomNumber'"
                                align="center"
                                :show-overflow-tooltip="true"
                                :min-width="5*remRatio">
                                 <!-- <template slot="header" slot-scope="scope">
                                    <div class="floor_header" @click="roomTypeFun(scope)">
                                        <p><span>{{roomName}}</span><i class="el-icon-arrow-down"></i></p>
                                        <el-select v-model="roomId" placeholder="" @change="roomIdChange" ref="roomRef">
                                            <el-option
                                              v-for="item in tableRoomNav"
                                              :key="item.id"
                                              :label="item.number"
                                              :value="item.id">
                                            </el-option>
                                        </el-select>
                                    </div>
                                </template> -->
                            </el-table-column>
                            <el-table-column
                                :label="'设备数量'"
                                :prop="'dev_count'"
                                align="center"
                                :show-overflow-tooltip="true"
                                :min-width="6.5*remRatio">
                            </el-table-column>
                            
                            <el-table-column
                                align="center"
                                :min-width="11*remRatio"
                                :label="'Operation'">
                                <template slot-scope="scope">
                                    <span class="btn" @click="setBlink(scope.row)" v-loading="scope.row.setBlink" :title="$t('App.airPurifiers.text26')">
                                        <i class="iconfont icon-liangdeng"></i>
                                    </span>
                                    <span class="btn" @click="getScene(scope.row)" :title="$t('App.airPurifiers.text27')">
                                        <i class="iconfont icon-shezhi"></i>
                                    </span>
                                    
                                </template>
                            </el-table-column>
                        </el-table>
                    <!-- </el-checkbox-group> -->
                    <div class="pagination_box">
                        <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="currentPage"
                            :page-size="pageSize"
                            layout="prev, pager, next"
                            :total="total">
                        </el-pagination>
                    </div>
                </div>
            </div>
        </div>

        <el-dialog
          title="设置情景模式"
          :visible.sync="dialogVisible2"
          class="dialogVisible_class"
          width="40rem">
          <el-form ref="sceneForm" :model="sceneForm" label-width="120px">
            <el-form-item label="亮度模式">
              <el-select v-model="sceneForm.light_mode">
                  <el-option label="常亮" value="Always_Brt"></el-option>
                  <el-option label="常灭" value="Always_Off"></el-option>
                  <el-option label="感应" value="Sensor_Control"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="色温(%)">
              <el-input-number v-model="sceneForm.cct_bright" :controls="false" :min="0" :max="100"></el-input-number>
            </el-form-item>
            <el-form-item label="感应模式">
              <el-select v-model="sceneForm.delay_mode">
                  <el-option label="一段" value="PhaseI"></el-option>
                  <el-option label="二段" value="PhaseII"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="恒照度模式">
              <el-select v-model="sceneForm.alscontrol_mode">
                  <el-option label="无效" value="None"></el-option>
                  <el-option label="自控" value="Inner"></el-option>
                  <el-option label="被控" value="Ext"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="一段延时(s)">
              <el-input-number v-model="sceneForm.delay_time" :controls="false" :min="5" :max="7200"></el-input-number>
            </el-form-item>
            <el-form-item label="二段延时(s)">
              <el-input-number v-model="sceneForm.delay_time2" :controls="false" :min="5" :max="7200"></el-input-number>
            </el-form-item>
            <el-form-item label="有人亮度(%)">
              <el-input-number v-model="sceneForm.high_bright" :controls="false" :min="0" :max="100"></el-input-number>
            </el-form-item>
            <el-form-item label="无人亮度(%)">
              <el-input-number v-model="sceneForm.standby_bright" :controls="false" :min="0" :max="100"></el-input-number>
            </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible2 = false">取 消</el-button>
            <el-button type="primary" @click="saveScene" v-loading="loading.saveScene">确 定</el-button>
          </span>
        </el-dialog>

        <!-- <button type="button" id="btn2" style="display: none"></button> -->
    </div>
</template>

<script type="text/javascript">
    // import sideBar from '../components/sideBar.vue'
    import { mapGetters } from 'vuex'
    import allUrl from '../../api/allUrl.js'
    import base from '../../api/base.js'
    export default {
        name:'lights',
        data () {
            return{
                dialogVisible:false,
                groupForm:{
                  id:'',
                  group_address:'',
                },

                dialogVisible2:false,
                sceneForm:{
                  id:'',
                  gatewayId:'',
                  
                  light_mode:'',
                  cct_bright:'',
                  delay_mode:'',
                  alscontrol_mode:'',
                  delay_time:'',
                  delay_time2:'',
                  high_bright:'',
                  standby_bright:'',
                },

                buildId:'',
                buildNav:[],
                keywords:'',
                floorNav:[],
                roomNav:[],

                lightId:'',
                lightArr:[],
                lightDataList:[],
                lightDataIdList:[],
                alertsArr:['normal','alerts'],
                onlineArr:['Off-line','On-line'],
                tableShowId:'',

                floorName:'Floor',
                floorId:'',
                roomName:'Room',
                roomId:'',
                tableFloorNav:[{id:'',number:''}],
                tableRoomNav:[{id:'',name:''}],

                currentPage:1,
                pageSize:20,
                total:0,

                lightsTkShowbg:false,
                lightsTkShow:false,
                lightsForm:{
                    name:'',
                    deviceId:'',
                    floorId:'',
                    roomId:'',
                    model:'',
                    gatewayId:'',
                    // type:'0',
                },
                modelNav:[{id:'0',name:'EL-DP02-1200-LY'},{id:'1',name:'EL-DP03-1200-LY'},{id:'2',name:'EL-WKDP03-1200-LY'}],
                lightsFormFloorName:'',
                lightsFormRoomName:'',
                lightTkTitle:'',
                software:'',
                firmware:'',

                batchBrightness:0,
                batchBrightnessShow:false,
                batchColor:0,
                batchColorShow:false,
                websocket:null,
                clientid:null,

                historyShowbg:false,
                historyShow:false,
                networHistoryType:'1',
                chartType:'0',
                chartTypeStr:'line',
                chartTypeArr:[{label:'Line',value:'0',str:'line'},{label:'Bar',value:'1',str:'bar'}],
                timeType1:'0',
                timeType2:'0',
                timeTypeStr:'Daily',
                timeTypeArr:[{label:'Daily',value:'0'},{label:'Weekly',value:'4'},{label:'Monthly',value:'1'},{label:'Yearly',value:'2'}],

                lightDataList2:[],
                lightArr2:[],

                currentPage2:1,
                pageSize2:20,
                total2:0,

                reDataIndex:0,

                loading:{
                    lightDataList:false,
                    lightDataList2:false,
                    lightDataList2_csv:false,
                    centralizedSettingSave:false,
                    saveGroup:false,
                    setBlink:false,
                    saveScene:false,
                },

                gatewayUpdateTkShowbg:false,
                gatewayUpdateTkShow:false,
                uploadGatewayVal:0,
                gatewayUpdateType:'1',
                gatewayUpdateSoftware:'',
                gatewayUpdateVersion:'',
                gatewayUpdateStatus:'1',

                img_lights_0:'',
                
                updateRemRatioShakeProof:null,
            }
        },
        computed:{
            ...mapGetters({
                token:'token',
                client_key:'client_key',
                username:'username',
                version:'version',

                remRatio:'remRatio',
                updateRemRatio:'updateRemRatio',

                role:'role',
                countryId:'countryId',
                provinceId:'provinceId',
                cityId:'cityId',
                hotelId:'hotelId',
                headerIdStr:'headerIdStr',
            }),
            lightsFormModelName(){
                let name = '';
                for(let d of this.modelNav){
                    if(d.id == this.lightsForm.model){
                        name = d.name
                    }
                }
                return name
            }
        },
        components:{
            // 'sideBar':sideBar
        },
        beforeDestroy(){
            if(this.websocket){
                this.websocket.close();
            }
        },
        mounted(){
            this.img_lights_0 = require('../../img/room/map/lights_0.png');

            if(this.version == '1'){
                this.img_lights_0 = require('../../img/room/map/lights_0_v1.png');
            }

            this.alertsArr = [this.$t('App.room_light.text59'),this.$t('App.room_light.text60')];
            this.onlineArr = [this.$t('App.room.text65'),this.$t('App.room.text66')];
            this.chartTypeArr = [{label:this.$t('App.room_light.text61'),value:'0',str:'line'},{label:this.$t('App.room_light.text62'),value:'1',str:'bar'}];

            this.timeTypeStr = this.$t('App.room_light.text63');
            this.timeTypeArr = [{label:this.$t('App.room_light.text63'),value:'0'},{label:this.$t('App.room_light.text64'),value:'4'},{label:this.$t('App.room_light.text65'),value:'1'},{label:this.$t('App.room_light.text66'),value:'2'}];

            this.floorName = this.$t('App.room.text29');
            this.roomName = this.$t('App.room.text30');


            this.$store.commit('SIDEBARSHOW',{
                sideBarShow:true,
            })
            this.lightArr = [
                {prop:'voltage',label:this.$t('App.lights.text25'),minWidth:5*this.remRatio,unit:'V'},
                {prop:'current',label:this.$t('App.lights.text26'),minWidth:5*this.remRatio,unit:'A'},
                {prop:'brightness',label:this.$t('App.lights.text27'),minWidth:(this.role==1?7.5:5.5)*this.remRatio,type:1},
                {prop:'color',label:this.$t('App.lights.text28'),minWidth:10*this.remRatio,type:1},
                {prop:'power',label:this.$t('App.lights.text29'),minWidth:10.5*this.remRatio,unit:'W'},
                {prop:'online',label:this.$t('App.lights.text30'),minWidth:8*this.remRatio,type:1},
                {prop:'alarmStatus',label:this.$t('App.lights.text31'),minWidth:10*this.remRatio,type:1},
                {prop:'updateTime',label:this.$t('App.lights.text32'),width:10*this.remRatio},
            ];
            
            this.getBuildNav(()=>{
                if(this.buildNav.length > 0){
                    this.buildId = this.buildNav[0].id;
                    this.tableFloorNav = [{id:'',name:''}];
                    this.getFloorNav(data=>{
                        for(let d of data.data.list){
                            this.tableFloorNav.push(d)
                        }
                    })
                    this.currentPage = 1;
                    this.getLightList();
                }else{
                    this.buildId = '';
                }
            });
        },
        methods:{
            getScene(obj){
              this.dialogVisible2 = true;
              // this.sceneForm.light_mode = data.cluster
              // this.sceneForm.id = data.id;
              
              for(let key in this.sceneForm){
                this.sceneForm[key] = ''
              }
              base.ajax_post(
                  allUrl.smartCampus.get_group_scene,
                  {
                      username:this.username,
                      client_key:this.client_key,
                      token:this.token,
                      id:obj.cluster,
                  },
                  {},
                  data=>{
                    // console.log(data)
                    for(let key in this.sceneForm){
                      this.sceneForm[key] = data.data[key]
                    }
                    this.sceneForm.id = obj.cluster;
                    this.sceneForm.gatewayId = obj.gatewayId;
                    
                  },
                  this
              )
            },
            saveScene(){
              this.loading.saveScene = true;
              base.ajax_post(
                    allUrl.smartCampus.set_scene,
                    {
                        username:this.username,
                        client_key:this.client_key,
                        token:this.token,
                        type:1,
                        ...this.sceneForm
                    },
                    {},
                    data=>{
                      this.loading.saveScene = false;
                      this.$message({
                        showClose: true,
                        message: data.msg,
                        type: 'success'
                      });
                    },
                    this,()=>{
                      this.loading.saveScene = false;
                    }
                )
            },
            setBlink(obj){
              obj.setBlink = true;
              base.ajax_post(
                    allUrl.smartCampus.set_blink,
                    {
                        username:this.username,
                        client_key:this.client_key,
                        token:this.token,
                        type:1,
                        id:obj.cluster,
                        gatewayId:obj.gatewayId
                    },
                    {},
                    data=>{
                      obj.setBlink = false;
                      this.$message({
                        showClose: true,
                        message: data.msg,
                        type: 'success'
                      });
                    },
                    this,()=>{
                      obj.setBlink = false;
                    }
                )
            },
         
        
            tableEnter(data){
              this.tableShowId = data.id;
            },
            tableLeave(){
              this.tableShowId = '-1';
            },
            /*设备列表*/
            getLightListKeyUp(e){
                if(e.key == 'Enter'){
                  this.getLightList();
                }
            },
            getLightList(callback){
                if(this.buildId){
                    this.loading.lightDataList = true;
                    base.ajax_post(
                        allUrl.smartCampus.get_group_list,
                        {
                            username:this.username,
                            client_key:this.client_key,
                            token:this.token,
                            page:this.currentPage,
                            count:this.pageSize,
                            
                            keywords:this.keywords,
                            buildId:this.buildId,
                            floorId:this.floorId,
                            roomId:this.roomId,
                        },
                        {},
                        data=>{
                            this.lightDataList = data.data.list;
                            this.loading.lightDataList = false;
                            this.total = Number(data.data.total);

                            let i = 1 + (this.currentPage-1)*this.pageSize;
                            for(let d of this.lightDataList){
                                this.$set(d,'setBlink',false);
                                d.webIndex = i;
                                i++;
                            }
                            if(callback){
                                callback(data)
                            }
                            this.$nextTick(function(){
                                this.$refs.lightDataList.doLayout();
                            })
                        },
                        this,()=>{
                            this.loading.lightDataList = false;
                        }
                    )
                    
                }
            },
            /*分页*/
            handleSizeChange(val) {
                this.pageSize = val;
                this.currentPage = 1;
                this.getLightList();
            },
            handleCurrentChange(val) {
                this.currentPage = val;
                this.getLightList();
                // console.log(val)
            },
            floorTypeFun(){
                this.$refs.floorRef.selectOption()
            },
            roomTypeFun(){
                this.$refs.roomRef.selectOption()
            },
            floorIdChange(val){
                for(let d of this.tableFloorNav){
                    console.log(val,d.id)
                    if(d.id == val){
                        this.$set(this,'floorName',d.name)
                        console.log(this.floorName)
                    }
                }
                if(val == ''){
                    this.floorName = 'Floor'
                }
                this.tableRoomNav = [{id:'',name:''}];
                if(this.floorId){
                    this.getRoomNav(this.floorId,data=>{
                        for(let d of data.data.list){
                            this.tableRoomNav.push(d)
                        }
                    })
                }
                this.currentPage = 1;
                this.getLightList();
            },
            roomIdChange(val){
                for(let d of this.tableRoomNav){
                    console.log(d.id,val)
                    if(d.id == val){
                        this.$set(this,'roomName',d.number)
                        console.log(this.roomName)
                    }
                }
                if(val == ''){
                    this.roomName = 'Room'
                }
                this.currentPage = 1;
                this.getLightList();
            },
            buildIdChange(){
                // this.getLightList();
                this.tableFloorNav = [{id:'',name:''}];
                this.getFloorNav(data=>{
                    for(let d of data.data.list){
                        this.tableFloorNav.push(d)
                    }
                })
                this.currentPage = 1;
                this.getLightList();
            },
            /*楼房下拉列表*/
            getBuildNav(callback){
                if(this.hotelId){
                    base.ajax_post(
                        allUrl.room.buildNav,
                        {
                            username:this.username,
                            client_key:this.client_key,
                            token:this.token,
                            hotelId:this.hotelId,
                        },
                        {},
                        data=>{
                            this.buildNav = data.data.list;
                            if(callback){
                                callback(data)
                            }
                        },
                        this
                    )
                }
            },
            /*楼层下拉列表*/
            getFloorNav(callback){
                base.ajax_post(
                    allUrl.room.floorNav,
                    {
                        username:this.username,
                        client_key:this.client_key,
                        token:this.token,
                        buildId:this.buildId,
                    },
                    {},
                    data=>{
                        if(callback){
                            callback(data)
                        }
                    },
                    this
                )
            },
        },
        watch:{
            hotelId:function(){
                this.getBuildNav(()=>{
                    if(this.buildNav.length > 0){
                        this.buildId = this.buildNav[0].id;
                        this.getFloorNav(data=>{
                            this.tableFloorNav = data.data.list
                        })
                        this.currentPage = 1;
                        this.getLightList();
                    }else{
                        this.buildId = '';
                    }
                });
            },
            updateRemRatio:function(){
                clearTimeout(this.updateRemRatioShakeProof)
                this.updateRemRatioShakeProof = setTimeout(()=>{
                    this.lightArr = [
                        {prop:'voltage',label:this.$t('App.lights.text25'),minWidth:5*this.remRatio,unit:'V'},
                        {prop:'current',label:this.$t('App.lights.text26'),minWidth:5*this.remRatio,unit:'A'},
                        {prop:'brightness',label:this.$t('App.lights.text27'),minWidth:(this.role==1?7.5:5.5)*this.remRatio,type:1},
                        {prop:'color',label:this.$t('App.lights.text28'),minWidth:9.5*this.remRatio,type:1},
                        {prop:'power',label:this.$t('App.lights.text29'),minWidth:10*this.remRatio,unit:'W'},
                        {prop:'online',label:this.$t('App.lights.text30'),minWidth:8*this.remRatio,type:1},
                        {prop:'alarmStatus',label:this.$t('App.lights.text31'),minWidth:10*this.remRatio,type:1},
                        {prop:'updateTime',label:this.$t('App.lights.text32'),width:10*this.remRatio},
                    ];
                    this.$nextTick(function(){
                        this.$refs.lightDataList.doLayout();
                    })
                },1000)
            }
        }
    }
</script>

<style type="text/css" lang="less">

    .classroomLights_main{
        width: 100%;
        height: 100%;
        // height: 105rem;
        min-height: 50rem;
        // min-width: 120rem;
        margin: 0 auto;
        overflow: hidden;
        position: relative;
        display: flex;
        background: #F6F8FA;
        &.cn{
            .classroomLights_right{
                .classroomLights_right_top .right_top_l > .el-input .el-icon-search{
                    background:linear-gradient(89deg,rgba(124,93,156,1) 0%,rgba(62,50,139,1) 100%);
                }
                .classroomLights_right_main .main_cont{
                    .el-table .brightness .btn_img .bg{
                        background:linear-gradient(89deg,rgba(124,93,156,1) 0%,rgba(62,50,139,1) 100%);
                    }
                    .el-table .btn:hover i{
                        color: #8266C7;
                    }
                    .pagination_box .el-pager li{
                        &:hover{
                            color: #513C93;
                            background:rgba(130,102,199,0.1);
                        }
                        &.active{
                            color: #FFFFFF;
                            background:linear-gradient(89deg,rgba(124,93,156,1) 0%,rgba(62,50,139,1) 100%);
                        }
                    }
                }
            }
            .classroomLights_wrap .classroomLights_box .btn_box .btn{
                background:linear-gradient(89deg,rgba(124,93,156,1) 0%,rgba(62,50,139,1) 100%);
            }
            .centralizedSetting_wrap .centralizedSetting_box .btn_box .btn{
                background:linear-gradient(89deg,rgba(124,93,156,1) 0%,rgba(62,50,139,1) 100%);
            }
            .history_warp .history_box{
                .table_box .pagination_box .el-pager li{
                    &:hover{
                        color: #513C93;
                        background:rgba(130,102,199,0.1);
                    }
                    &.active{
                        color: #FFFFFF;
                        background:linear-gradient(89deg,rgba(124,93,156,1) 0%,rgba(62,50,139,1) 100%);
                    }
                }
                .table_top_box .box1 .btn.select{
                    background:linear-gradient(89deg,rgba(124,93,156,1) 0%,rgba(62,50,139,1) 100%);
                }
            }
            .illuminance_wrap .classroomLights_box .btn_box .btn{
                background:linear-gradient(89deg,rgba(124,93,156,1) 0%,rgba(62,50,139,1) 100%);
            }
        }
        .classroomLights_left{
            width: 11.67rem;
            height: 100%;
            min-width: 130px;
        }
        .classroomLights_right{
            position: relative;
            padding: 1.92rem 1.5rem 0;
            width: calc(100% - 11.67rem);
            height: calc(100%);
            .classroomLights_right_top{
                display: flex;
                justify-content: space-between;
                .right_top_l{
                    .el-input__inner{
                        height: 2.5rem;line-height: 2.5rem;
                        border-radius: 1.25rem;
                        font-family: AlibabaPuHuiTiR;
                        font-size: 1rem;
                        color: #333333;
                        border-color: #F0F0F0;
                    }
                    .el-input__icon{
                        height: 2.5rem;line-height: 2.5rem;
                    }
                    .el-select{
                        width: 15rem;
                    }
                    >.el-input{
                        margin-left: 1rem;
                        width: 20rem;
                        .el-icon-search{
                            display: inline-block;
                            top: 0;bottom: 0;
                            right: 0;
                            width: 4rem;
                            background: #05CFAB;
                            border-radius: 1.25rem;
                            cursor: pointer;
                            color: #FFFFFF;
                        }
                        .el-input__suffix{
                            right: 0;
                        }
                    }
                }
            }
            .classroomLights_right_main{
                height: calc(100% - 6.5rem);
                margin-top: 1rem;
                position: relative;
                background: #FFFFFF;
                border: 1px solid #F0F0F0;
                border-radius: 0.4rem;
                .main_top{
                    width: 100%;
                    display: flex;
                    justify-content: space-between;
                    padding: 0 1.67rem 0;
                    .main_top_l{
                        .div1{
                            margin-top: 1.5rem;
                            font-family: AlibabaPuHuiTiB;
                            font-size: 1.5rem;
                            color: #333333;
                        }
                        .div2{
                            margin-top: 1.33rem;
                            display: flex;
                            align-items: center;
                            .btn{
                                margin-left: 1.29rem;
                                display: flex;align-items: center;
                                font-family: AlibabaPuHuiTiR;
                                font-size: 1rem;
                                color: #333333;
                                cursor: pointer;
                                i{
                                    font-size:1rem;
                                    color: #C6CDD5;
                                }
                                span{
                                    margin-left: 0.5rem;
                                }
                            }
                        }
                    }
                    .main_top_r{
                        margin-top: 2.33rem;
                        display: flex;
                        .btn{
                            margin-left: 1rem;
                            height: 2.5rem;line-height: 2.5rem;
                            padding: 0 1.25rem;
                            background: #FFFFFF;
                            border: 1px solid #F0F0F0;
                            border-radius: 1.25rem;
                            font-family: PingFang-SC-Medium;
                            font-size: 1rem;
                            color: #333333;
                            cursor: pointer;
                            display: flex;
                            align-items: center;
                            img{
                                margin-right: 0.5rem;
                                height: 1rem;
                            }
                        }
                    }
                }
                .main_cont{
                    height: calc(100% - 11rem);
                    margin-top: 0.75rem;
                    .el-checkbox-group{
                        height: 100%;
                    }
                    .el-table{
                        .el-checkbox{
                            margin-left: 1.1rem;
                        }
                        .btn{
                            padding: 0.5rem;
                            cursor: pointer;
                            &+.btn{
                                margin-left: 0.2rem;
                            }
                            i{
                                color: #A3AFBB;
                                font-size:0.8rem;
                            }
                            &:hover{
                                i{
                                    color: #05CFAB;
                                }
                            }
                        }
                        th{
                            font-weight:initial;
                            height: 3rem;
                            border-top: 1px solid #F0F0F0;
                            border-bottom: 1px solid #F0F0F0;
                            padding: 0;
                            background: #F6F8FA;
                            &>.cell{
                                height: 3rem;line-height: 3rem;
                                font-family: AlibabaPuHuiTiR;
                                font-size: 1rem;
                                color: #333333;
                                padding: 0;
                            }
                            div{
                                height: 3rem;line-height: 3rem;
                            }
                        }
                        td{
                            padding: 0;
                            height: 3rem;
                            &>.cell,.el-checkbox__label{
                                font-family: AlibabaPuHuiTiR;
                                font-size: 1rem;
                                color: #657085;
                                // line-height: 3rem;
                            }
                        }
                        .el-loading-spinner{
                            height: 100%;
                            margin-top: 0;top: 50%;
                        }
                        .cell{
                            .el-loading-spinner{
                                height: 100%;
                                margin-top: 0;top: 0;
                                .circular{
                                    width: 1.5rem;height: 1.5rem;
                                }
                            }
                            
                        }
                        .floor_header{
                            width: 100%;
                            position: relative;
                            cursor: pointer;
                            padding: 0;
                            p{
                                background-color: rgba(246,248,250,1);
                            }
                            .el-select{
                                position: absolute;
                                top: 0;
                                left: 0;
                                z-index: -1;
                                width: 100%;
                            }
                            .el-input__inner{
                                height:2.7rem;line-height:2.7rem;
                                border: none;
                                background-color: inherit;

                                font-size:1.1rem;
                                font-weight:500;
                                font-family:PingFang-SC-Medium,PingFang-SC;
                                color:rgba(142,159,175,1);
                            }
                        }
                        .brightness{
                            display: flex;
                            align-items: center;
                            justify-content:flex-end;
                            height: 3rem;
                            .text{
                                // margin-left: auto;
                                position: relative;
                            }
                            >.loading{
                                display: inline-block !important;
                            }
                            >.input_loading{
                                display: none !important;
                            }
                            &:hover{
                                >.text{
                                    display: none;
                                }
                                .el-input-number{
                                    display: inline-block;
                                }
                            }
                            .el-input-number{
                                display: none;
                                .el-input{
                                    height: 2rem;line-height: 2rem;
                                    .el-input__inner{
                                        height: 2rem;line-height: 2rem;
                                        padding: 0;text-align: center;
                                        font-family: AlibabaPuHuiTiR;
                                        font-size: 1rem;
                                        color: #657085;
                                    }
                                } 
                            }
                            .btn_img{
                                display: block;
                                margin-right: auto;
                                margin-left: 0.58rem;
                                margin-right: 0.5rem;
                                width: 1.5rem;height: 1.5rem;line-height: 1.5rem;
                                background: #05CFAB;
                                border-radius: 0.4rem;
                                background-color:rgba(5,207,171,0.4);
                                position: relative;
                                cursor: pointer;
                                i{
                                    color: #FFFFFF;
                                    font-size:0.7rem;
                                    position: relative;z-index: 1;
                                }
                                &:hover{
                                    i{
                                        top: 0.1rem;
                                        font-size: 1rem;
                                    }
                                }
                                .bg{
                                    position: absolute;
                                    width: 100%;height: 100%;
                                    bottom: 0;left: 0;
                                    background-color:rgba(5,207,171,1);
                                    border-radius: 0.4rem;
                                }
                            }
                            .light_dg{
                                display: block;
                                width: 1.5rem;height: 1.5rem;
                                cursor: pointer;
                                background-image: url('../../img/room/light_dg_0.png');
                                background-size: 100% 100%;
                                background-position: center;
                                color: rgba(0,0,0,0);
                                &:hover{
                                    background-image: url('../../img/room/light_dg_1.png');
                                }
                            }
                        }
                        .color{
                            display: flex;
                            align-items: center;
                            justify-content:center;
                            .text{
                                // margin-left: auto;
                            }
                            .btn_img{
                                display: inline-block;
                                margin-right: auto;
                                margin-left: 0.58rem;
                                width: 1.5rem;height: 1.5rem;line-height: 1.5rem;
                                background: #05CFAB;
                                border-radius: 0.4rem;
                                background-color:rgba(255,190,0,0.4);
                                position: relative;
                                cursor: pointer;
                                // font-size: 12
                                i{
                                    color: #FFFFFF;
                                    font-size:0.7rem;
                                    position: relative;z-index: 1;
                                }
                                &:hover{
                                    i{
                                        top: 0.1rem;
                                        font-size: 1rem;
                                    }
                                }
                                .bg{
                                    position: absolute;
                                    width: 100%;height: 100%;
                                    bottom: 0;left: 0;
                                    background-color:rgba(255,190,0,1);
                                    border-radius: 0.4rem;
                                }
                            }
                        }
                        .alarmStatus{
                            .text_1{
                                cursor: pointer;
                                color: rgba(255,12,77,1);
                                i{
                                    margin-left: 0.2rem;
                                    font-size: 1rem;
                                }
                            }
                        }
                        .online{
                            width: 4.8rem;
                            height: 1.8rem;
                            line-height: 1.8rem;
                            background: rgba(246,248,250,1);
                            border-radius: 0.67rem;
                            margin: 0 auto;
                            span{
                                position: relative;
                                margin: 0 0.3rem;
                                color:rgba(235, 239, 242, 1);
                            }
                            .iconfont{
                                font-size: 1.2rem;
                            }
                        }
                    }
                    .pagination_box{
                        .el-pagination{
                            float: right;
                            margin-top: 0.5rem;
                        }
                        height: 2.5rem;line-height: 2.5rem;
                        .btn-prev .el-icon{
                            font-size:1rem;
                            color: #666666;
                            font-family: PingFang-SC-Medium;
                        }
                        button{
                            width: 2.33rem;height: 2.33rem;line-height: 2.33rem;
                            padding: 0;
                            background: #F6F8FA;
                            border-radius: 0.2rem;
                        }
                        .el-pager li{
                            margin-left: 0.83rem;
                            width: 2.33rem;height: 2.33rem;line-height: 2.33rem;
                            padding: 0;
                            background: #F6F8FA;
                            border-radius: 0.2rem;
                            &:hover{
                                color: rgba(5,207,171,1);
                                background-color: rgba(5,207,171,0.1);
                            }
                        }
                        .btn-next{
                            margin-left: 0.83rem;
                        }
                        .el-pager li.active{
                            background: #05CFAB;
                            color: #FFFFFF;
                        }
                    }
                }
            }
        }
        .classroomLights_wrap{
            position: fixed;
            top: 0;left: 0;right: 0;bottom: 0;
            z-index: 2000;
            .classroomLights_wrap_bg{
                position: absolute;
                top: 0;left: 0;width: 100%;height: 100%;min-height: 50rem;
                background-color:rgba(57,57,57,0.3);
            }
            // overflow: hidden;
            .classroomLights_box{
                position: absolute;
                width: 36rem;height: 100%;
                min-height: 50rem;
                background: #FFFFFF;
                box-shadow: 0 0 8px 0 rgba(0,0,0,0.12);
                right: -36rem;
                transition: all 0.5s;
                &.classroomLights_tk_show{
                    right: 0rem; 
                }
                .classroomLights_title{
                    height: 4.1rem;line-height: 4.1rem;
                    display: flex;
                    justify-content: space-between;
                    padding: 0 2.5rem 0 2.5rem;
                    border: 0.1rem solid rgba(240,240,240,1);
                    .span1{
                        font-family: PingFang-SC-Medium;
                        font-size: 1.17rem;
                        color: #333333;
                    }
                    .span2{
                        padding: 0 0.5rem;
                        font-family: PingFang-SC-Medium;
                        font-size: 1.17rem;
                        color: #999999;
                        cursor: pointer;
                    }
                }
                .form{
                    margin-top: 1.96rem;
                    .form_item{
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        height: 3.33rem;line-height: 3.33rem;
                        margin: 0 2.5rem 1.67rem;
                        padding: 0 1.67rem 0 1.08rem;
                        background: #F6F8F7;
                        .laber{
                            font-family: PingFang-SC-Medium;
                            font-size: 1rem;
                            color: #333333;
                        }
                        .el-dropdown{
                            cursor: pointer;
                            i{
                                margin-left: 1.67rem;
                            }
                        }
                        .el-input{
                            width: calc(100% - 8rem);
                            .el-input__inner{
                                font-family: PingFang-SC-Medium;
                                font-size: 1rem;
                                color: #657085;
                                text-align: right;
                                background: initial;
                                border: none;
                            }
                        }
                    }
                }
                .btn_box{
                    position: absolute;
                    width: 100%;
                    bottom: 1.67rem;
                    .btn{
                        width: 11.67rem;height: 2.67rem;line-height: 2.67rem;
                        margin: 0 auto;
                        background: #05CFAB;
                        border-radius: 0.2rem;
                        text-align:center;
                        cursor: pointer;
                        font-family: PingFang-SC-Medium;
                        font-size: 1rem;
                        color: #FFFFFF;
                    }
                }
            }
        }
        .illuminance_wrap{
            position: fixed;
            top: 0;left: 0;right: 0;bottom: 0;
            z-index: 2000;
            .classroomLights_wrap_bg{
                position: absolute;
                top: 0;left: 0;width: 100%;height: 100%;min-height: 50rem;
                background-color:rgba(57,57,57,0.3);
            }
            // overflow: hidden;
            .classroomLights_box{
                position: absolute;
                width: 36rem;height: 100%;
                min-height: 50rem;
                background: #FFFFFF;
                box-shadow: 0 0 8px 0 rgba(0,0,0,0.12);
                right: -36rem;
                transition: all 0.5s;
                &.classroomLights_tk_show{
                    right: 0rem; 
                }
                .classroomLights_title{
                    height: 4.1rem;line-height: 4.1rem;
                    display: flex;
                    justify-content: space-between;
                    padding: 0 2.5rem 0 2.5rem;
                    border: 0.1rem solid rgba(240,240,240,1);
                    .span1{
                        font-family: PingFang-SC-Medium;
                        font-size: 1.17rem;
                        color: #333333;
                    }
                    .span2{
                        padding: 0 0.5rem;
                        font-family: PingFang-SC-Medium;
                        font-size: 1.17rem;
                        color: #999999;
                        cursor: pointer;
                    }
                }
                .form{
                    margin-top: 1.96rem;
                    .form_item{
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        height: 3.33rem;line-height: 3.33rem;
                        margin: 0 2.5rem 1.67rem;
                        padding: 0 0.5rem 0 1rem;
                        background: #F6F8F7;
                        position: relative;
                        .laber{
                            font-family: PingFang-SC-Medium;
                            font-size: 1rem;
                            color: #333333;
                        }
                        .el-input{
                            // width: calc(100% - 12rem);
                            margin-right: 1rem;
                            flex: 1;
                            .el-input__inner{
                                padding: 0 1rem;
                                height: 3.33rem;line-height: 3.33rem;
                                font-family: PingFang-SC-Medium;
                                font-size: 1rem;
                                color: #657085;
                                text-align: right;
                                background: initial;
                                border: none;
                            }
                        }
                        .unit{
                            position: absolute;
                            right: 6rem;
                        }
                        .btn{
                            // width: 4rem;
                            margin-left: 1rem;
                            height: 2rem;
                            line-height: 2rem;
                            padding: 0 1rem;
                            text-align: center;
                            background: #FFFFFF;
                            border: 1px solid #F0F0F0;
                            // border-radius: 1.25rem;
                            font-family: PingFang-SC-Medium;
                            font-size: 1rem;
                            color: #333333;
                            cursor: pointer;
                        }
                    }
                }
                .btn_box{
                    position: absolute;
                    width: 100%;
                    bottom: 1.67rem;
                    .btn{
                        width: 11.67rem;height: 2.67rem;line-height: 2.67rem;
                        margin: 0 auto;
                        background: #05CFAB;
                        border-radius: 0.2rem;
                        text-align:center;
                        cursor: pointer;
                        font-family: PingFang-SC-Medium;
                        font-size: 1rem;
                        color: #FFFFFF;
                    }
                }
            }
        }
        .history_warp{
            position: fixed;
            top: 0;left: 0;right: 0;bottom: 0;
            z-index: 2000;
            .history_warp_bg{
                position: absolute;
                top: 0;left: 0;width: 100%;height: 100%;min-height: 50rem;
                background-color:rgba(57,57,57,0.3);
            }
            .history_box{
                position: absolute;
                width: 80.42rem;height: 100%;min-height: 50rem;
                background: #FFFFFF;
                box-shadow: 0 0 8px 0 rgba(0,0,0,0.12);
                right: -80.42rem;
                transition: all 0.5s;
                &.history_show{
                   right: 0rem; 
                }
                .history_top{
                    height: 4.1rem;line-height: 4.1rem;
                    display: flex;
                    justify-content: space-between;
                    padding: 0 2rem 0 2.5rem;
                    border: 0.1rem solid rgba(240,240,240,1);
                    .span1{
                        font-family: PingFang-SC-Medium;
                        font-size: 1.17rem;
                        color: #333333;
                    }
                    .span2{
                        padding: 0 0.5rem;
                        font-family: PingFang-SC-Medium;
                        font-size: 1.17rem;
                        color: #999999;
                        cursor: pointer;
                    }
                }
                .filter_box{
                    height: 4.3rem;
                    padding: 1.63rem 0 0rem;
                    padding-left: 2.5rem;
                    .el-select{
                        margin-right: 0.83rem
                    }
                    .el-input__inner,.el-input__icon{
                        height: 2.5rem;line-height: 2.5rem;
                    }
                    .el-input__inner{
                        border-radius: 1.25rem;
                    }
                }
                .table_top_box{
                    position: relative;
                    .download_btn{
                        position: absolute;
                        right: 3rem;top: 0.12rem;

                        height: 2.5rem;line-height: 2.5rem;
                        padding: 0 1.25rem;
                        background: #FFFFFF;
                        border: 1px solid #F0F0F0;
                        border-radius: 1.25rem;
                        font-family: PingFang-SC-Medium;
                        font-size: 1rem;
                        color: #333333;
                        cursor: pointer;
                    }
                    .box1{
                        display: flex;
                        width: 18.5rem;height: 2.75rem;line-height: 2.75rem;
                        background-color:rgba(246, 248, 250, 1);
                        border-radius:1.38rem;
                        margin: 0.8rem auto 0.8rem;
                        .btn{
                            flex: 1;
                            text-align: center;
                            font-size:1rem;
                            font-family:AlibabaPuHuiTiR;
                            color:rgba(51,51,51,1);
                            cursor: pointer;
                            &.select{
                                background-color:rgba(5, 207, 171, 1);
                                color:rgba(255,255,255,1);
                                border-radius:1.67rem;
                            }
                        }
                    }
                }
                .echarts_warp{
                    height:calc(100%  - 13rem);
                }
                .echarts_box{
                    height: calc(17rem);
                    margin: 0 1.8rem 1.67rem 2.5rem;
                    background: #F6F8F7;
                    border-radius: 5px;
                    .echarts_top{
                        padding-left: 1.67rem;
                        line-height: 2.5rem;
                        font-family: AlibabaPuHuiTiB;
                        font-size: 1rem;
                        color: #333333;
                    }
                    .history_echarts_tooltip{
                        background-color:#fff;
                        padding: 0.3rem 1rem 0.67rem 0;
                        .p1{
                            display: flex;
                            align-items: center;
                            font-size:1rem;
                            font-family:AlibabaPuHuiTiM;
                            color:rgba(51,51,51,1);
                            i{
                                margin-left: 0.92rem;
                                margin-right: 0.5rem;
                                display: inline-block;
                                width: 0.25rem;height: 0.25rem;
                                border-radius: 50%;
                            }
                            .span1{
                                margin-right: 0.3rem;
                            }
                        }
                        .p2{
                            font-size:1rem;
                            font-family:AlibabaPuHuiTiM;
                            color:rgba(163,175,187,1);
                            padding-left: 1.75rem;
                        }

                    }
                    .history_echarts_box1{
                        width: 100%;height: calc(100% - 2.5rem);
                    }
                    .history_echarts_box2{
                        width: 100%;height: calc(100% - 2.5rem);
                    }
                    .history_echarts_box3{
                        width: 100%;height: calc(100% - 2.5rem);
                    }
                    .history_echarts_box4{
                        width: 100%;height: calc(100% - 2.5rem);
                    }
                    .history_echarts_box5{
                        width: 100%;height: calc(100% - 2.5rem);
                    }
                    .history_echarts_box6{
                        width: 100%;height: calc(100% - 2.5rem);
                    }
                    .history_echarts_box7{
                        width: 100%;height: calc(100% - 2.5rem);
                    }
                }
                .table_box{
                    height: calc(100% - 17rem);
                    .el-table{
                        .el-loading-spinner{
                            margin-top: -0.75rem;
                            .circular{
                                width: 1.5rem;height: 1.5rem;
                            }
                        }
                        th{
                            font-weight:initial;
                            height: 3rem;
                            border-top: 1px solid #F0F0F0;
                            border-bottom: 1px solid #F0F0F0;
                            padding: 0;
                            background: #F6F8FA;
                            &>.cell{
                                height: 3rem;line-height: 3rem;
                                font-family: AlibabaPuHuiTiR;
                                font-size: 1rem;
                                color: #333333;
                            }
                            div{
                                height: 3rem;line-height: 3rem;
                            }
                        }
                        td{
                            padding: 0;
                            height: 3rem;
                            &>.cell,.el-checkbox__label{
                                font-family: AlibabaPuHuiTiR;
                                font-size: 1rem;
                                color: #657085;
                            }
                        }
                        .brightness{
                            display: flex;
                            align-items: center;
                            justify-content:flex-end;
                        }
                        .color{
                            display: flex;
                            align-items: center;
                            justify-content:center;
                        }
                        .alarmStatus{
                            .text_1{
                                color: rgba(255,12,77,1);
                                img{
                                    margin-left: 0.2rem;
                                }
                            }   
                        }
                    }
                    .pagination_box{
                        margin-top: 0.5rem;
                        .el-pagination{
                            float: right;
                            // margin-top: 0.5rem;
                            padding:0;
                        }
                        height: 2.5rem;line-height: 2.5rem;
                        .btn-prev .el-icon{
                            font-size:1rem;
                            color: #666666;
                            font-family: PingFang-SC-Medium;
                        }
                        button{
                            width: 2.33rem;height: 2.33rem;line-height: 2.33rem;
                            padding: 0;
                            background: #F6F8FA;
                            border-radius: 0.2rem;
                        }
                        .el-pager li{
                            margin-left: 0.83rem;
                            width: 2.33rem;height: 2.33rem;line-height: 2.33rem;
                            padding: 0;
                            background: #F6F8FA;
                            border-radius: 0.2rem;
                            &:hover{
                                color: rgba(5,207,171,1);
                                background-color: rgba(5,207,171,0.1);
                            }
                        }
                        .btn-next{
                            margin-left: 0.83rem;
                        }
                        .el-pager li.active{
                            background: #05CFAB;
                            color: #FFFFFF;
                        }
                    }
                }
            }
        }
        .gatewayUpdate_wrap{
            position: fixed;
            top: 0;left: 0;right: 0;bottom: 0;
            z-index: 2000;
            .gatewayUpdate_wrap_bg{
                position: absolute;
                top: 0;left: 0;width: 100%;height: 100%;min-height: 50rem;
                background-color:rgba(57,57,57,0.3);
            }
            // overflow: hidden;
            .gatewayUpdate_box{
                position: absolute;
                width: 36rem;height: 100%;
                min-height: 50rem;
                background: #FFFFFF;
                box-shadow: 0 0 8px 0 rgba(0,0,0,0.12);
                right: -36rem;
                transition: all 0.5s;
                &.gateway_tk_show{
                    right: 0rem; 
                }
                .gatewayUpdate_title{
                    height: 4.1rem;line-height: 4.1rem;
                    display: flex;
                    justify-content: space-between;
                    padding: 0 2.5rem 0 2.5rem;
                    border: 0.1rem solid rgba(240,240,240,1);
                    .span1{
                        font-family: PingFang-SC-Medium;
                        font-size: 1.17rem;
                        color: #333333;
                    }
                    .span2{
                        padding: 0 0.5rem;
                        font-family: PingFang-SC-Medium;
                        font-size: 1.17rem;
                        color: #999999;
                        cursor: pointer;
                    }
                }
                .box1{
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    width:calc(100% - 5rem);
                    height:5.08rem;
                    margin:2.5rem auto 0;
                    padding: 0 1.5rem;
                    background:rgba(246,248,247,1);
                    img{
                        height: 3rem;
                    }
                    span{
                        font-size:1.67rem;
                        font-family:AlibabaPuHuiTiH;
                        color:rgba(51,51,51,1);
                    }
                }
                .p1{
                    width:calc(100% - 5rem);
                    margin:0.75rem auto 0;
                    height:1.42rem;
                    line-height:1.42rem;
                    font-size:1rem;
                    font-family:AlibabaPuHuiTiR;
                    color:rgba(101,112,133,1);
                }
                .btn_box{
                    width:calc(100% - 5rem);
                    margin:2rem auto 0;
                    height:2.67rem;
                    background:rgba(5, 207, 171, 0.1);
                    .btn{
                        width: 100%;height: 100%;line-height: 2.67rem;
                        text-align: center;
                        background:rgba(5,207,171,1);
                        border-radius:0.17rem;

                        font-size:1rem;
                        font-family:PingFang-SC-Medium,PingFang-SC;
                        font-weight:500;
                        color:rgba(255,255,255,1);
                        cursor: pointer;
                    }
                    .el-progress{
                        .el-loading-mask{
                            background: rgba(255,255,255,0.1);
                        }
                        .el-progress-bar__outer{
                            height: 2.67rem;
                            background-color:initial;
                            border-radius: 0;
                            .el-progress-bar__inner{
                                border-radius: 0;
                                background-color:rgba(5, 207, 171, 1);
                            }
                        }
                    }
                    .text{
                        width: 100%;height: 100%;line-height: 2.67rem;
                        text-align: center;
                        border-radius:0.17rem;
                        font-size:1rem;
                        font-family:PingFang-SC-Medium,PingFang-SC;
                        font-weight:500;
                        color:rgba(255,255,255,1);
                        &.span1{
                            background-color: rgba(255, 12, 77, 1);
                            cursor:pointer;
                        }
                        &.span2{
                            background-color: rgba(165, 201, 195, 1);
                        }
                    }
                }
            }
        }
        .centralizedSetting_wrap{
            position: fixed;
            top: 0;left: 0;right: 0;bottom: 0;
            z-index: 2000;
            .centralizedSetting_wrap_bg{
                position: absolute;
                top: 0;left: 0;width: 100%;height: 100%;min-height: 88rem;
                background-color:rgba(57,57,57,0.3);
            }
            // overflow: hidden;
            .centralizedSetting_box{
                position: absolute;
                width: 36rem;height: 100%;
                min-height: 88rem;
                background: #FFFFFF;
                box-shadow: 0 0 8px 0 rgba(0,0,0,0.12);
                right: -36rem;
                transition: all 0.5s;
                &.centralizedSetting_tk_show{
                    right: 0rem; 
                }
                .centralizedSetting_title{
                    height: 4.1rem;line-height: 4.1rem;
                    display: flex;
                    justify-content: space-between;
                    padding: 0 2.5rem 0 2.5rem;
                    border: 0.1rem solid rgba(240,240,240,1);
                    .span1{
                        font-family: PingFang-SC-Medium;
                        font-size: 1.17rem;
                        color: #333333;
                    }
                    .span2{
                        padding: 0 0.5rem;
                        font-family: PingFang-SC-Medium;
                        font-size: 1.17rem;
                        color: #999999;
                        cursor: pointer;
                    }
                }
                .form{
                    margin: 3rem 2.5rem 0;
                    .form_item{
                        margin-bottom: 1.67rem;
                        border: 1px solid #EBEFF2;
                        .form_item_title{
                            background: #F6F8F7;
                            height: 3.33rem;line-height:3.33rem;
                            padding-left: 1rem;
                            font-family: PingFang-SC-Bold;
                            font-size: 1rem;
                            color: #333333;
                        }
                        .form_item_box{
                            display: flex;
                            border-top: 1px solid #EBEFF2;
                            .li{
                                height: 4.1rem;line-height: 4.1rem;
                                display: flex;
                                align-items: center;
                                justify-content: space-between;
                                padding: 0 1rem;
                                .laber{
                                    font-family: AlibabaPuHuiTiR;
                                    font-size: 1rem;
                                    color: #333333;
                                }
                                .el-select{
                                    width: 6rem;
                                    .el-input--suffix .el-input__inner{
                                        padding-right: 1.5rem;
                                    }
                                    .el-input__suffix{
                                        right: 0;
                                        .el-input__icon{
                                            width: 1.5rem;
                                            line-height:4rem;
                                        }
                                    }
                                    .el-input__inner{
                                        text-align: right;
                                        height: 4rem;line-height: 4rem;
                                        border: none;
                                        padding-left: 0;
                                    }
                                }
                            }
                            .li1{
                                flex: 1;
                                border-right: 1px solid #EBEFF2;
                            }
                            .li2{
                                flex: 1.4;
                            }
                        }
                    }
                }
                .btn_box{
                    width:calc(100% - 5rem);
                    margin:2rem auto 0;
                    height:2.67rem;
                    background:rgba(5, 207, 171, 0.1);
                    .btn{
                        width: 100%;height: 100%;line-height: 2.67rem;
                        text-align: center;
                        background:rgba(5,207,171,1);
                        border-radius:0.17rem;

                        font-size:1rem;
                        font-family:PingFang-SC-Medium,PingFang-SC;
                        font-weight:500;
                        color:rgba(255,255,255,1);
                        cursor: pointer;
                    }
                }
            }
        }
        .dialogVisible_class{
          .el-input-number,.el-select{
            width: 20rem;
            .el-input__inner{
              text-align: left;
            }
          }
        }
    }
</style>